import React, {Component} from "react";
import {
  Panel,
  PanelGroup,
  Button,
  ButtonGroup,
  Table
}                         from "react-bootstrap";
import ReactHighcharts    from "react-highcharts";

import { REPORTS }        from "actions/const";

import RawReport          from "./RawReport";

export default class EventNameReport extends Component {
  constructor (props) {
    super(props);
  }

  render () {
    let {
      Reports,
      actions,

      getEventNameReport,
      history
    } = this.props;

    let {
      isLoadingEventNameReport,
      eventNameReportData,
      chartType,
      sorting
    } = Reports;

    let renderSortIcon = (assingedColumn = "event") => {
      let {
        column,
        sort
      } = sorting;

      let iconName = "",
          isAscending = sort.toUpperCase() === "ASCENDING" ? true : false;

      iconName = isAscending ? `sort-${assingedColumn === "event" ? "alpha" : "numeric"}-asc` : `sort-${assingedColumn === "event" ? "alpha" : "numeric"}-desc`;

      if (column === assingedColumn) {
        return <i className={`fa fa-${iconName}`}/>
      } else {
        return "";
      }
    };

    let chart = "";

    switch (chartType) {
      case 0:
        chart = (
          <ReactHighcharts
            config={
              {
                chart: {
                  plotBackgroundColor: null,
                  plotBorderWidth: null,
                  plotShadow: false,
                  type: "pie"
                },
                title: {
                  text: null
                },
                subtitle: {
                  text: null
                },
                tooltip: {
                  pointFormat: "{series.name}: <b>{point.percentage:.1f}%</b>"
                },
                plotOptions: {
                  pie: {
                    allowPointSelect: true,
                    cursor: "pointer",
                    dataLabels: {
                      enabled: false
                    },
                    showInLegend: true
                  }
                },
                series: [
                  {
                    name: "Events",
                    colorByPoint: true,
                    data: eventNameReportData.map((item) => (
                      {
                        name: item.get("eventName"),
                        y: item.get("total")
                      }
                    ))
                  }
                ]
              }
            }
            />
        );
        break;
      case 1:
        chart = (
          <ReactHighcharts
            config={
              {
                chart: {
                  type: "column"
                },
                title: {
                  text: null
                },
                subtitle: {
                  text: null
                },
                xAxis: {
                  crosshair: true,
                  type: "category"
                },
                yAxis: {
                  min: 0,
                  title: {
                    text: "Total"
                  }
                },
                plotOptions: {
                  column: {
                    pointPadding: 0.2,
                    borderWidth: 0
                  }
                },
                tooltip: {
                  headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
                  pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
                      '<td style="padding:0"><b>{point.y}</b></td></tr>',
                  footerFormat: '</table>',
                  shared: true,
                  useHTML: true
                },
                series: eventNameReportData.map((item) => ({
                  name: item.get("eventName"),
                  data: [
                    {
                      name: "Overall",
                      y: item.get("total")
                    }
                  ]
                }))
              }
            }
            />
        );
        break;
      case 2:
        chart = (
          <Table striped bordered hover
            style={{ marginTop: 50 }}>
            <thead>
              <tr>
                <th>
                  <a
                    href="javascript:void(0)"
                    onClick={() => {
                      let isAscending = sorting.sort.toUpperCase() === "ASCENDING";

                      let clone = eventNameReportData.map((item) => item).sort((a, b) => {
                        let item1 = a.get("eventName") || "",
                            item2 = b.get("eventName") || "";

                        if (item1 < item2) {
                          return isAscending ? 1 : -1;
                        } else if (item1 > item2) {
                          return isAscending ? -1 :1;
                        }
                        return 0;
                      });

                      actions.setValue(
                        REPORTS,
                        {
                          eventNameReportData: clone,
                          sorting: {
                            column: "event",
                            sort: isAscending ? "descending" : "ascending"
                          }
                        }
                      );
                    }}
                    >
                    Event {renderSortIcon("event")}
                  </a>
                </th>
                <th>
                  <a
                    href="javascript:void(0)"
                    onClick={() => {
                      let isAscending = sorting.sort.toUpperCase() === "ASCENDING";

                      let clone = eventNameReportData.map((item) => item).sort((a, b) => {
                        let item1 = a.get("total") || "",
                            item2 = b.get("total") || "";

                        if (item1 < item2) {
                          return isAscending ? 1 : -1;
                        } else if (item1 > item2) {
                          return isAscending ? -1 :1;
                        }
                        return 0;
                      });

                      actions.setValue(
                        REPORTS,
                        {
                          eventNameReportData: clone,
                          sorting: {
                            column: "total",
                            sort: isAscending ? "descending" : "ascending"
                          }
                        }
                      );
                    }}
                    >
                    Total {renderSortIcon("total")}
                  </a>
                </th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {eventNameReportData.map((item, index) => {
                return (
                  <tr key={index}>
                    <td>{item.get("eventName")}</td>
                    <td>{item.get("total")}</td>
                    <td>
                      <a
                        className="fa fa-eye fa-lg"
                        href="javascript:void(0)"
                        onClick={() => {
                          console.log();
                          history.push(history.location.pathname+"/"+item.id)
                        }}
                        />
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        );
        break;
      case 3:
        chart = <RawReport />
        break;
      default:

    }

    return (
      <Panel>
        <Panel.Heading style={{
          backgroundColor: '#D1282F',
          color: 'white'
        }}>
          <h4>Event Report</h4>
        </Panel.Heading>
        <Panel.Body>
          <ButtonGroup
            style={{ float: "right" }}
            >
            {[ "Pie", "Bar", "Table", "Raw" ].map((item, index) => (
              <Button
                active={chartType === index}
                onClick={() => {
                  actions.setValue(
                    REPORTS,
                    {
                      chartType: index
                    }
                  );
                }}
                >
                {item}
              </Button>
            ))}
          </ButtonGroup>
          {chart}
          {/*
            <PanelGroup>
              {eventNameReportData.map((item) => (
                <Panel
                  style={{
                    display: "inline-block",
                    margin: 5,
                    cursor: "pointer"
                  }}
                  onClick={() => {
                    history.push("/report/"+item.id)
                  }}
                  >
                  <Panel.Heading>
                    <h4>{item.get("eventName")}</h4>
                  </Panel.Heading>
                  <Panel.Body>
                    Total: <h4 style={{ display: "inline-block" }}>{item.get("total")}</h4>
                  </Panel.Body>
                </Panel>
              ))}
            </PanelGroup>
            */}
          {/*
            <ButtonGroup
              style={{ float: "right" }}>
              {[ "Overall", "Daily", "Weekly", "Monthly", "Quarterly", "Yearly" ].map((item, index) => (
                <Button
                  active={reportType === index}
                  onClick={() => {
                    this.setState(
                      {
                        reportType: index
                      },
                      () => {
                        getEventNameReport();
                      }
                    );
                  }}
                  >
                  {item}
                </Button>
              ))}
            </ButtonGroup>
            <Panel>
              <Panel.Body>
                <ReactHighcharts
                  config={
                    {
                      chart: {
                        type: "bar"
                      },
                      title: {
                        text: "Screen event"
                      },
                      subtitle: {
                        text: null
                      },
                      xAxis: {
                        categories: categories,
                        title: {
                          text: null
                        }
                      },
                      yAxis: {
                        min: 0,
                        title: {
                          text: "Total"
                        }
                      },
                      plotOptions: {
                        bar: {
                          dataLabels: {
                            enabled: true
                          }
                        }
                      },
                      series: [{
                        name: 'Year 1800',
                        data: data
                      }]
                    }
                  }
                  />
              </Panel.Body>
            </Panel>
            */}
        </Panel.Body>
      </Panel>
    );
  }
}



// WEBPACK FOOTER //
// ./components/Report/EventNameReport.js